import React from 'react';

import "./Tile.css";

export default function Tile(props) {
  return <div className="mdl-cell mdl-cell--3-col-desktop mdl-cell--4-col-tablet mdl-cell--4-col-phone">
        <img alt={props.img} className="skill-size" src={`${props.img}.png`} />
      </div>
}



// WEBPACK FOOTER //
// ./src/Tile/Tile.js